import { render } from "./InspectorView.vue?vue&type=template&id=6432a663&ts=true"
import script from "./InspectorView.vue?vue&type=script&lang=ts"
export * from "./InspectorView.vue?vue&type=script&lang=ts"

import "./InspectorView.vue?vue&type=style&index=0&id=6432a663&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__